/* ZSportsTech — section-zhero.js
   Scoped to #sc-zhero (The Z Story · §01 documentary hero).
   Vanilla JS only, no frameworks. Maps to → assets/section-zhero.js.
   ─────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var hero = document.getElementById('sc-zhero');
  if (!hero) return;

  /* ── Background video — play only while on-screen ──────────
     Activates if a <video> is dropped into .sc-zhero__bg-wrap
     from section settings (settings.hero_video / poster).      */
  var wrap = hero.querySelector('.sc-zhero__bg-wrap');
  var vid  = wrap ? wrap.querySelector('video') : null;

  if (vid) {
    vid.setAttribute('playsinline', '');
    vid.setAttribute('muted', '');
    vid.muted = true; /* iOS requires programmatic mute */

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            vid.play().catch(function () {});
          } else {
            vid.pause();
          }
        });
      }, { threshold: 0.1 });
      obs.observe(hero);
    } else {
      vid.play().catch(function () {});
    }
  }

  /* ── Reduced-motion: freeze the eyebrow dot pulse ───────── */
  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  var dot = hero.querySelector('.sc-zhero__dot');
  function applyMotionPref() {
    if (dot) dot.style.animationName = mq.matches ? 'none' : '';
  }
  applyMotionPref();
  if (mq.addEventListener) { mq.addEventListener('change', applyMotionPref); }

}());
